import React from "react";
import UserCreate from "./UserCreate";


export default function User() {
    return (
        <UserCreate/>
    )
}